import Abstract from "../../../abstract-view/abstract.js";

export default class Form extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._resetButtonWrapper = null;
    this._resetButton = null;
  }

  getResetButtonWrapper() {
    if (!this._resetButtonWrapper) {
      this._resetButtonWrapper = this._element.querySelector(`.filter-reset-button-wrapper`);
    }

    return this._resetButtonWrapper;
  }

  getResetButton() {
    if (!this._resetButton) {
      this._resetButton = this.getResetButtonWrapper().querySelector(`button`);
    }

    return this._resetButton;
  }

  setResetButtonText(text) {
    if (this.getResetButton()) {
      this.getResetButton().textContent = text;
    }
  }

  getResetButtonText() {
    return (this.getResetButton()) ? this.getResetButton().textContent : null;
  }

  clearData() {
    const data = this._element.dataset;
    Object.keys(data)
      .forEach((key) => {
        delete this._element.dataset[key];
      });
  }
}
